import { DateTime } from 'luxon';

import { TimeResetFrequencyEnum } from 'constants-content';

export const BEGINNING_OF_TIME = new Date(0);
export const END_OF_TIME = new Date(253402300799999);

export function getResetDateRange(
  date: Date,
  period: TimeResetFrequencyEnum,
  zone: string
): { startDate: Date; endDate: Date } {
  const baseDate = DateTime.fromJSDate(date).setZone(zone);
  const now = DateTime.now().setZone(zone);

  switch (period) {
    case 'Hourly':
      return {
        startDate: DateTime.max(baseDate, now.startOf('hour')).toJSDate(),
        endDate: now.endOf('hour').toJSDate(),
      };
    case 'Daily':
      return {
        startDate: DateTime.max(baseDate, now.startOf('day')).toJSDate(),
        endDate: now.endOf('day').toJSDate(),
      };
    case 'Weekly':
      return {
        startDate: DateTime.max(baseDate, now.startOf('week')).toJSDate(),
        endDate: now.endOf('week').toJSDate(),
      };
    case 'Monthly':
      return {
        startDate: DateTime.max(baseDate, now.startOf('month')).toJSDate(),
        endDate: now.endOf('month').toJSDate(),
      };
    case 'Yearly':
      return {
        startDate: DateTime.max(baseDate, now.startOf('year')).toJSDate(),
        endDate: now.endOf('year').toJSDate(),
      };

    default:
      return {
        startDate: BEGINNING_OF_TIME,
        endDate: END_OF_TIME, // End
      };
  }
}
